var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return [_c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
          click: function click() {
            return _vm.$emit('click');
          }
        } : {}), [_vm._t("icon"), _c('v-list-item-content', [!_vm.small ? _c('v-list-item-subtitle', [!_vm.hasActionListener ? _c('tooltip', {
          attrs: {
            "text": _vm.item.statusReadable
          }
        }, [_c('v-avatar', {
          staticClass: "mr-1 white--text",
          attrs: {
            "color": _vm.item.statusColor,
            "elevation": 0,
            "size": "8"
          }
        })], 1) : _vm._e(), _c('span', [_vm._v(" " + _vm._s(_vm._f("ddmmyyyhhmm")(_vm.item.timestamp.created)) + " ")])], 1) : _vm._e(), _c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.emitOpenDetail.apply(null, arguments);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.item.displayTitle) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.displayTitle) + " ")])]), !_vm.small ? _c('v-list-item-subtitle', [_vm.item.from ? _c('span', [_c('v-icon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("mdi-phone")]), _vm._v(" " + _vm._s(_vm.item.from) + " ")], 1) : _vm._e(), _vm.item.durationFormatted ? _c('span', [_c('v-icon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("mdi-timer-outline")]), _vm._v(" " + _vm._s(_vm.item.durationFormatted) + " ")], 1) : _vm._e()]) : _vm._e()], 1), _vm.confirmable ? _c('v-list-item-action', {
          staticClass: "mx-0 px-0"
        }, [_c('v-flex', [hover ? _c('v-btn', {
          attrs: {
            "text": "",
            "color": "success",
            "elevation": "0",
            "small": "",
            "href": "tel:".concat(_vm.item.from)
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.call")) + " "), _c('v-icon', {
          staticClass: "pl-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-phone ")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 2)];
      }
    }], null, true)
  }) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }